import { API_URL } from "../utils/auth";

async function parse(response) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data?.detail || data?.error?.message || data?.message || "Checkout could not be prepared.");
    error.data = data;
    error.status = response.status;
    throw error;
  }
  return data;
}

export async function fetchCheckoutStripeConfig({ signal } = {}) {
  return parse(await fetch(`${API_URL}/checkout/stripe-config/`, {
    headers: { Accept: "application/json" },
    signal,
  }));
}

export async function validateCheckoutCart(payload, { signal } = {}) {
  return parse(await fetch(`${API_URL}/checkout/validate-cart/`, {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    signal,
  }));
}

export async function createCheckoutPaymentIntent(payload, { signal } = {}) {
  return parse(await fetch(`${API_URL}/checkout/payment-intent/`, {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    signal,
  }));
}


export async function saveCheckoutContact(orderId, payload, { signal } = {}) {
  return parse(await fetch(`${API_URL}/checkout/orders/${orderId}/contact/`, {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    signal,
  }));
}


export async function fetchCheckoutOrderSummary(orderId, checkoutToken, { signal } = {}) {
  const params = new URLSearchParams({ checkout_token: checkoutToken || "" });
  return parse(await fetch(`${API_URL}/checkout/orders/${orderId}/summary/?${params.toString()}`, {
    headers: { Accept: "application/json" },
    signal,
  }));
}
